<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-11-29 11:36:15
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-05-19 11:02:18
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="top-info">
        <span class="cell number">
          <i
            class="iconfont icon-dingdanbianhao"
            style="font-size: 20px; margin-right: 5px"
          ></i>
          订单编号：{{ detail.orderNum }}
        </span>
        <span class="cell">委托方：{{ detail.client }}</span>
        <span class="cell">订单类型：{{ detail.orderTypeName }}</span>
      </div>
      <el-table
        class="table-machine-info"
        :data="info"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="cropIdName"
          label="种植作物"
          min-width="10%"
          align="center"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          prop="orderTime"
          label="作业时间要求"
          min-width="22%"
          align="center"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          prop="workTypeNames"
          label="作业类型"
          min-width="18%"
          align="center"
          :resizable="false"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="orderArea"
          label="托管面积（亩）"
          min-width="18%"
          align="center"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          prop="workArea"
          label="作业面积（亩）"
          min-width="18%"
          align="center"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          prop="statusName"
          label="状态"
          min-width="14%"
          align="center"
          :resizable="false"
        >
        </el-table-column>
      </el-table>
      <el-tabs v-model="activeName">
        <el-tab-pane label="订单作业地块" name="first"
          ><OrderLand v-if="isRequest" :orderId="id"></OrderLand
        ></el-tab-pane>
        <el-tab-pane label="订单完成情况" name="second"
          ><OrderCompletion v-if="isRequest" :orderId="id"></OrderCompletion
        ></el-tab-pane>
        <el-tab-pane label="订单结算情况" name="third"
          ><OrderSettlement v-if="isRequest" :orderId="id"></OrderSettlement
        ></el-tab-pane>
        <el-tab-pane label="订单原件" name="fourth">
          <OriginalFile v-if="isRequest" :type="3" :bizId="id"></OriginalFile>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-main>
</template>

<script>
import OrderLand from "./components/OrderLand";
import OrderCompletion from "./components/OrderCompletion";
import OrderSettlement from "./components/OrderSettlement";
import OriginalFile from "@/components/OriginalFile";
export default {
  name: "OrderDetail",
  components: {
    OrderLand,
    OrderCompletion,
    OrderSettlement,
    OriginalFile,
  },
  data() {
    return {
      id: "",
      detail: {},
      info: [],
      activeName: "first",
      isRequest: false,
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getOrderDetail();
  },
  methods: {
    /**
     * @descripttion: 获取订单详情
     * @Author: juanjuanhui
     * @Date: 2021-11-25 10:45:30
     * @param {*}
     */
    getOrderDetail() {
      this.$http.order.getOrderDetail({ id: this.id }).then((res) => {
        this.isRequest = true;
        this.detail = res.data;
        this.info = [res.data];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.main {
  .top-info {
    display: flex;
    align-items: center;
    padding-top: 10px;
    color: #018388;
    .cell {
      display: flex;
      align-items: center;
      margin-right: 4%;
      &.number {
        font-weight: 900;
      }
    }
  }
  ::v-deep .el-table {
    &.table-machine-info {
      margin-top: 20px;
    }
    thead {
      color: #5f6868;
      .el-table__cell {
        font-weight: normal;
        background-color: #f1f5f8;
      }
    }
  }
}
</style>
